module.exports = __webpack_public_path__ + "companies-frontend-b21b3468/managed-empty-state-49eafdd7f97c74df9ff86313fbdbaccb.png";